import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

/**
 * Last-resort UI so a syntax/runtime error on an older Android WebView
 * does not leave a blank white screen.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message || 'Unknown error' };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Portal render error', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="compat-crash" role="alert">
        <h1>राजधर्म गुरुकुल</h1>
        <p>
          यह पृष्ठ इस ब्राउज़र पर खुलते समय अटक गया। कृपया पृष्ठ पुनः लोड करें,
          या Chrome / Samsung Internet का नवीनतम संस्करण आज़माएँ।
        </p>
        <p>
          This page failed to load in this browser. Please reload, or try the
          latest Chrome or Samsung Internet.
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload / पुनः लोड करें
        </button>
      </div>
    );
  }
}
